'use client';

import { c as _c } from "react/compiler-runtime";
import { useOverlayStackPresence } from '@/app/components/overlays/hooks/useOverlayStackPresence';
import { MODAL_KEYS } from '@/app/constants/overlayKeys';
import { SPARTAN_PRODUCT_TOP_NAV_INTEREST_MODAL_ID } from '@/app/lcv/components/sections/spartan/products/shared/top-navigation/interest-modal/constants';
import { SPARTAN_PRODUCT_TOP_NAV_MOBILE_MENU_ID, SPARTAN_PRODUCT_TOP_NAV_MODEL_MENU_ID } from '@/app/lcv/components/sections/spartan/products/shared/top-navigation/tracking';
export const useSpartanProductTopNavigationMediaPause = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      overlayKey: MODAL_KEYS.MODAL_CUSTOM,
      instanceId: SPARTAN_PRODUCT_TOP_NAV_MOBILE_MENU_ID
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isMobileMenuOpen = useOverlayStackPresence(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      overlayKey: MODAL_KEYS.MODAL_CUSTOM,
      instanceId: SPARTAN_PRODUCT_TOP_NAV_INTEREST_MODAL_ID
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isInterestModalOpen = useOverlayStackPresence(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      overlayKey: MODAL_KEYS.MODAL_CUSTOM,
      instanceId: SPARTAN_PRODUCT_TOP_NAV_MODEL_MENU_ID
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isModelMenuOpen = useOverlayStackPresence(t2);
  return isMobileMenuOpen || isInterestModalOpen || isModelMenuOpen;
};